import { render, staticRenderFns } from "./ShopifyPrice.vue?vue&type=template&id=f53d2d7c"
import script from "./ShopifyPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopifyPrice.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports